export default {
    message: {
        required: true,
    },
    name: {
        required: true,
        maxlength: 50
    },
    phone: {
        required: false,
        optional_phone: true
    },
    email: {
        required: true,
        email: true
    },
    policyCheck: {
        required: true
    },
}